/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

export enum PaymentOrderType {
    PAYMENT_OUT = 'PAYMENT_OUT',
    DIRECT_DEBIT_OUT = 'DIRECT_DEBIT_OUT',
    DIRECT_DEBIT_IN = 'DIRECT_DEBIT_IN',
    REQUEST_TO_PAY_OUT = 'REQUEST_TO_PAY_OUT',
    REQUEST_TO_PAY_IN = 'REQUEST_TO_PAY_IN',
    E_PAYMENT_OUT = 'E_PAYMENT_OUT',
    INSTANT_PAYMENT_OUT = 'INSTANT_PAYMENT_OUT',
    INSTANT_E_PAYMENT_OUT = 'INSTANT_E_PAYMENT_OUT',
    UNKNOWN = 'UNKNOWN',
}
